import StudyPlan from './model';

const reviver = ([key, val]) => {
  switch (key) {
    case 'coreCourseId': {
      if (val === 0) return [key, undefined];
      return [key, val];
    }
    case 'otherOptions':
    case 'nonCoreCourseId': {
      if (val === null) return [key, undefined];
      return [key, val];
    }

    default:
      return [key, val];
  }
};

const create = (data) => new StudyPlan(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/StudyPlan/result/create.js